import { Component, OnInit } from '@angular/core';
import { ReportJobService } from '../../services/report-job.service';

@Component({
  selector: 'app-last-offers',
  templateUrl: './last-offers.component.html',
  styleUrls: ['./last-offers.component.css']
})
export class LastOffersComponent implements OnInit {

  public loading;
  max: number = 5;
  page: number = 1;
  total: number = 0;

  public jobs: any;

  constructor(
    private reportJobService: ReportJobService
  ) { }

  ngOnInit() {
    this.jobs = [];
    this.loading = true;
    this.searchOffers(this.page);
  }

  searchOffers(page: number) {
    this.reportJobService.getReportJobWithUpdate(page, this.max)
    .subscribe(res => {
        this.page = page;
        this.total = res.pagination.total;
        this.loading = false;
        this.jobs = res.report_jobs;
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/last-offers/last-offers.component.ts